import React from "react";
import UsersTable from "components/Tables/users/Users";

const ListUser = () => {
  return (
    <div>
      <UsersTable />
    </div>
  );
};

export default ListUser;
